/**
 * borrowed from NU ultipro-web
 */
import { APP_INITIALIZER, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService, Config } from './config.service';
import { Util } from '../../../../util';
import { MockConfigService } from './mock.config.service';
import { firstValueFrom } from 'rxjs';

const ConfigEndpoint = Util.prependHost('config.json');

export async function fetchConfig(http: HttpClient, configService: ConfigService) {
  if (configService instanceof MockConfigService) {
    return;
  }

  try {
    const config = await firstValueFrom(http.get<Config>(ConfigEndpoint));

    configService.init(config);
  } catch (err) {
    console.error(
      `App could not start! Could not fetch configuration from endpoint '${ConfigEndpoint}'`,
      err
    );
    throw err;
  }
}

export function fetchConfigFactory(
  http: HttpClient,
  configService: ConfigService
): () => Promise<void> {
  return () => fetchConfig(http, configService);
}

export const ConfigInitializer: Provider = {
  provide: APP_INITIALIZER,
  useFactory: fetchConfigFactory,
  deps: [HttpClient, ConfigService],
  multi: true,
};
